import Image from "next/image";

const HeroSection = () => (
  <div className="bg-black overflow-x-hidden xl:overflow-auto">
    <div>
      <div className="flex justify-center items-center flex-col pt-32">
        <div className="h-80 w-full absolute left-0 right-0 top-4 bg-radial-gradient-roaddy-hero"></div>
        <div className="[&>span]:!h-28 [&>span]:!w-24 [&>span]:xl:!w-32 [&>span]:xl:!h-40">
          <Image
            alt="Roaddy - A Roadside service assistance mobile app logo"
            loading="lazy"
            src="/assets/case-study/roaddy/roaddy-logo-mobile.webp"
            width={133}
            height={160}
            layout="fixed"
          />
        </div>
        <h1 className="text-6xl md:text-8xl font-normal bg-gradient-roaddy-hero-title bg-clip-text text-transparent">
          <span className="font-righteous">Roaddy</span>
        </h1>
      </div>
      <div className="flex justify-center items-center flex-col">
        <p className="text-lg md:text-xl w-3/4 md:w-3/4 font-normal xl:text-2xl xl:leading-snug mt-6 xl:mb-4 text-center xl:w-1/2 mx-auto text-gray-300">
          <span className="font-gilroy">
            Roaddy is a roadside assistance app designed to help people anytime,
            anywhere in case of vehicle breakdown.
          </span>
        </p>
        <div>
          <Image
            alt="roaddy-anim"
            src="/assets/case-study/roaddy/hero-anim.webp"
            width={1888}
            height={365}
            layout="fixed"
            priority
          />
        </div>
      </div>
    </div>
    <div className="w-full flex px-4 xl:px-48">
      <div className="w-4/12 pb-4 pl-4 md:pl-8 xl:pl-0 xl:pb-4">
        <p className="text-white font-light text-sm md:text-base">
          <span className="font-gilroy">Project Type</span>
        </p>
        <p className="font-bold text-xs md:text-base text-white font-gilroy mb-4 xl:mb-0 md:w-4/5 xl:w-full">
          <span className="font-gilroy">UI/UX & Mobile Development</span>
        </p>
      </div>
      <div className="pl-5 md:pl-8 xl:pl-28 w-4/12">
        <p className="text-white font-light text-sm md:text-base font-gilroy">
          <span className="font-gilroy">Industry</span>
        </p>
        <p className="font-bold text-xs md:text-base text-white font-gilroy">
          <span className="font-gilroy">Service App</span>
        </p>
      </div>
      <div className="pl-4 md:pl-8 xl:pl-16 w-4/12">
        <p className="text-white font-light text-sm md:text-base font-gilroy">
          <span className="font-gilroy">Technology used</span>
        </p>
        <p className="font-bold text-xs md:text-base text-white font-gilroy">
          <span className="font-gilroy">
            Figma, After Effects, Kotlin, Swift
          </span>
        </p>
      </div>
    </div>
  </div>
);

export default HeroSection;
